export default "__VITE_ASSET__CmKXZVC$__"